module.exports = "/_next/static/images/TrainingAndHackathons-63e406f0d12494e478d32c2ad99c5107.png";